import React, { useState } from "react";
import { Badge, Button, Empty, List, Popover, Typography } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/es";
import { useUser } from "../../context/UserContext";
import { useNotificaciones } from "../../hooks/useNotificaciones";

dayjs.extend(relativeTime);
dayjs.locale("es");

const { Text } = Typography;

const fechaRelativa = (n) => (n.creada && n.creada.toDate ? dayjs(n.creada.toDate()).fromNow() : "");

// Campana con las notificaciones sin leer. Se muestra solo si hay sesión.
const CampanaNotificaciones = () => {
  const { userData } = useUser();
  const { pendientes, marcarLeida, marcarTodas } = useNotificaciones(userData?.uid);
  const [abierto, setAbierto] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  if (!userData) return null;

  const abrir = (n) => {
    marcarLeida(n.id);
    setAbierto(false);
    if (n.enlace) {
      if (isDashboard && n.enlace.startsWith("/disputa/")) {
        navigate(`/dashboard${n.enlace}`);
      } else {
        navigate(n.enlace);
      }
    }
  };

  const contenido = (
    <div style={{ width: 320, maxWidth: "80vw" }}>
      {pendientes.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No tienes notificaciones nuevas" />
      ) : (
        <List
          size="small"
          dataSource={pendientes.slice(0, 8)}
          renderItem={(n) => (
            <List.Item style={{ cursor: "pointer" }} onClick={() => abrir(n)}>
              <List.Item.Meta
                title={<Text strong>{n.titulo}</Text>}
                description={
                  <>
                    <div>{n.mensaje}</div>
                    <Text type="secondary" style={{ fontSize: 11 }}>{fechaRelativa(n)}</Text>
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
        <Button type="link" size="small" disabled={pendientes.length === 0} onClick={marcarTodas}>
          Marcar todas como leídas
        </Button>
        <Link to={isDashboard ? "/dashboard/notificaciones" : "/notificaciones"} onClick={() => setAbierto(false)}>Ver todas</Link>
      </div>
    </div>
  );

  return (
    <Popover content={contenido} title="Notificaciones" trigger="click" placement="bottomRight" open={abierto} onOpenChange={setAbierto}>
      <Badge count={pendientes.length} size="small" overflowCount={99}>
        <Button type="text" shape="circle" icon={<BellOutlined style={{ fontSize: 18 }} />} aria-label="Notificaciones" />
      </Badge>
    </Popover>
  );
};

export default CampanaNotificaciones;
